// Example: pluralize(0, 'section') -> "0 section", pluralize(2, 'signal', 'signaux') -> "2 signaux"
export const pluralize = (count, singular, plural = `${singular}s`) =>
  `${count} ${count > 1 ? plural : singular}`
